<template>
  <div class="izin">
    <BackSection :menu="name" />
    <div class="container-fluid">
      <ListDataWish />
    </div>
  </div>
</template>

<script>
import BackSection from "@/components/BackSection.vue";
import ListDataWish from "@/components/ListDataWish.vue";
export default {
  setup() {
    return {
      name: "List Wish",
    };
  },
  components: {
    ListDataWish,
    BackSection,
  },
};
</script>
